<template>
    <div id="ContainerAuditList">
        <div class="row">
            <div class="col-12">
                <MdTitle v-bind:Text= "$t('Shared.AuditTitle')"/>
                <div class="row">
                    <div class="col-sm-12 col-md-12 mb-12">
                        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group" dir="ltr">
                                <input 
                                    type="text" 
                                    class="form-control"
                                    :dir="dirInput"
                                    v-model="paramAudits.SearchCriteria"
                                    @keyup.enter="SearchAudits(true)"
                                >
                                <div class="input-group-append">
                                    <MdButton 
                                        v-bind:Name="'btnsearchinput'"
                                        v-bind:VariantProp="'btn btn-sm search-attached'"
                                        v-bind:IconClass="'mdi mdi-magnify'"
                                        v-on:click="SearchAudits(true)">
                                    </MdButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row"> 
                    <b-col md="3" lg="3" sm="12">
                        <!--<MdEdit 
                            v-bind:Label="$t('Shared.datefrom')"
                            v-bind:TypeProp="'date'" 
                            v-bind:Name="'DateFrom'"
                            v-model="paramAudits.DateFrom"
                            v-bind:Min="'1900-01-01'"
                            v-bind:Max="'2200-12-31'"                    
                            v-bind:Id="'input_audit_date_from'"
                            v-bind:OnPressEnter="HandleDatePressEnter"
                            @change="HandleDatePressEnter">                                     
                        </MdEdit>-->
                        <MdDateTime 
                            :Label="$t('Shared.datefrom')" 
                            :Model="paramAudits.DateFrom"                           
                            @input="paramAudits.DateFrom = $event"                            
                            :Id="'AuditListingDateFrom'"
                            :Type="'date'" 
                            :OnPressEnter="HandleDatePressEnter"                         
                            :isConfirm="false"
                            :ReadOnly="false">
                        </MdDateTime>
                    </b-col>
                    <b-col md="3" lg="3" sm="12">
                        <!--<MdEdit 
                            v-bind:Label="$t('Shared.dateTo')"
                            v-bind:TypeProp="'date'" 
                            v-bind:Name="'DateTo'"
                            v-model="paramAudits.DateTo"
                            v-bind:Min="'1900-01-01'"
                            v-bind:Max="'2200-12-31'"                  
                            v-bind:Id="'input_audit_date_to'"
                            v-bind:OnPressEnter="HandleDatePressEnter"
                            @change="HandleDatePressEnter">                                     
                        </MdEdit>-->
                        <MdDateTime 
                            :Label="$t('Shared.dateTo')" 
                            :Model="paramAudits.DateTo"                           
                            @input="paramAudits.DateTo = $event"                            
                            :Id="'AuditListingDateTo'"
                            :Type="'date'" 
                            :OnPressEnter="HandleDatePressEnter"                         
                            :isConfirm="false"
                            :ReadOnly="false">
                        </MdDateTime>

                    </b-col>

                    <b-col md="3" lg="3" sm="12">
                        <MdSelect
                            v-bind:Label="$tc('Shared.ActionsTxt')"
                            v-bind:Options="ActionOptions"
                            v-bind:ModelArray="ActionModel"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"                      
                            :Input="ChangeAction"
                            v-bind:Multiple="true"
                            v-bind:AllowEmpty="true"/>
                    </b-col>
                    <b-col md="3" lg="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('AuditList.Module')"
                            v-bind:Options="ModuleOptions"
                            v-bind:ModelArray="ModuleModel"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"                      
                            :Input="ChangeModule"
                            v-bind:Multiple="true"
                            v-bind:AllowEmpty="true"/>
                    </b-col>
                </div>

                <div class="row">
                    <b-col md="3" lg="3" sm="12">
                        <MdSelect
                            v-bind:Label="$tc('Shared.Patient',2)"
                            v-bind:Options="PatientsList"
                            v-bind:ModelArray="PatientsModel"
                            v-bind:FieldDescription="'patientname'"
                            v-bind:FieldCode="'patientcode'"
                            v-bind:Placeholder="selectPlaceholder"
                            v-bind:Multiple="true"
                            v-bind:RequireEvent="true"
                            :Input="ChangeDropDownPatients"
                            :CustomLabel="customLabelPatients"
                            v-bind:AllowEmpty="true"/>
                    </b-col>
                </div>

                <b-row>
                    <b-col md="12">
                        <div class="text-center text-md-right mt-3">
                            <button 
                                v-on:click="SearchAudits(true)"
                                        type="button"
                                        class="btn btn-primary btn-login mx-2 pull-right"												
                                        id="btnsearchinput">
                                            {{ $t('Shared.Search') }}
                            </button>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div>
                    <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                    <MdTable
                        v-bind:fields="fields"
                        v-bind:items="items"
                        v-bind:totalRows="totalRows"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                        v-bind:currentPage="currentPage"
                        v-bind:perPage="perPage"
                        v-bind:pageOptions="pageOptions"
                        v-bind:refTable="refTable"
                        :viewIconEvent="GoToAudit"
                        :pageChanged="pageChanged"
                        :perPageFunction="PerPageFunction">
                    </MdTable>
                </div>
            </div>
        </div>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('AuditList.Settings')"
                v-bind:Name="'btnWebAuditSettings'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="goToWebAuditSettings()"/>
        </div>

        <AuditAuthDialog
            v-bind:VisibleDialog="isAuthDialogVisible"
            v-model="AuthItem"
            @close="handleClose"
        >
        </AuditAuthDialog>

        <AuditCRUDDialog
            v-bind:VisibleDialog="isCRUDDialogVisible"
            v-model="CrudItem"
            @close="handleClose"
        >
        </AuditCRUDDialog>

        <AuditClinicalNoteDialog
            v-bind:VisibleDialog="isClinicalNotesDialogVisible"
            v-model="ClinicalNoteItem"
            @close="handleClose"
        >
        </AuditClinicalNoteDialog>

        <AuditClinicalNoteDocumentDialog
            v-bind:VisibleDialog="isClinicalNoteDocumentDialogVisible"
            v-model="ClinicalNoteDocumentItem"
            @close="handleClose"
        >
        </AuditClinicalNoteDocumentDialog>
    </div>
</template>

<script>
import moment from 'moment'
import EnumService from '@/services/enum.service'
import PatientService from '@/services/patient.service' 
import AuditService from '@/services/audit.service' 
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import Utils from '@/common/utils'
import { EventBus } from '@/event-bus.js';
import AuditUtils from '@/components/pages/audit/AuditUtils.js'
import Permission from '@/common/Permission'

export default {
    name: 'AuditList',
    mixins: [ShowMessage, DBFunctions, Permission],

    data() {
        return {
            OptionsRightMenu:{
                visible:false,
                ItemsList:[],
                btnvisible:false,
                itemdisabled: false,
                PatientCode:'',
                Mode:this.edit_mode,
                favButtonAtion:false          
            },
            ShowMessageIsEmpty:false,
            paramAudits:{
                SearchCriteria:'',
                PageNumber : 1,
                PageSize: 10,
                DateFrom: moment(this.NewDate).format("YYYY-MM-DD"),
                DateTo: moment(this.NewDate).format("YYYY-MM-DD"),
                Patients: '',
                Modules: '',
                ActionCode: ''
            },
            fields: [
                { key: 'sysDate', sortable: true, label: this.$t('Shared.Date'), class: 'text-rigth' }, 
                { key: 'userName', sortable: true, label: this.$t('AuditList.UserName'), class: 'text-rigth' },       
                { key: 'actionTrans', sortable: true, label: this.$tc('Shared.ActionsTxt'), class: 'text-rigth' },  
                { key: 'moduleTrans', sortable: true, label: this.$t('AuditList.Module'), class: 'text-rigth' },
                { key: 'entityName', sortable: true, label: this.$t('AuditList.Entity'), class: 'text-rigth' },
                { key: 'entityKey', sortable: true, label: this.$t('AuditList.PrimaryKey'), class: 'text-rigth' },
                { key: 'entityKeyValue', sortable: true, label: this.$t('AuditList.PrimaryKeyValue'), class: 'text-rigth' },
                { key: 'patientName', sortable: true, label: this.$t('Shared.PatientName'), class: 'text-rigth' }
            ],
            pageOptions: [5, 10, 15],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            ActionOptions: EnumService.AuditActionTypeList.sort((a, b) => {
                const x = a.text.toLowerCase();
                const  y = b.text.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
            }),
            ModuleOptions: EnumService.AuditModuleTypeList.sort((a, b) => {
                const x = a.text.toLowerCase();
                const  y = b.text.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
            }),
            refTable: 'selectableTable',
            PatientsList: [],
            selectPlaceholder: this.$t('ClinicalNotes.SelectOptions'),
            items: [],
            ActionModel: null,
            ModuleModel: null,
            SelectedItem: null,
            AuthItem: null,
            CrudItem: null,
            ClinicalNoteItem: null,
            ClinicalNoteDocumentItem: null,
            PatientsModel: null,
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
        };
    },

    computed: {
        isClinicalNotes() {
            return this.SelectedItem != null && ((this.SelectedItem.module == 'Clinical Notes') || (this.SelectedItem.module == 'Group Notes')) && this.SelectedItem.entityKey.toLowerCase() == 'headerid';
        },

        isCRUDDialogVisible() {
            return this.SelectedItem != null && (this.SelectedItem.action == 'WAA_VIEW' || (['WAA_INSERT', 'WAA_UPDATE', 'WAA_DELETE'].indexOf(this.SelectedItem.action) != -1 && !this.isClinicalNotes)); //((this.SelectedItem.module != 'Clinical Notes') || !this.SelectedItem.customFrame);
        },

        isClinicalNotesDialogVisible() {
            return this.SelectedItem != null && ['WAA_INSERT', 'WAA_UPDATE', 'WAA_DELETE'].indexOf(this.SelectedItem.action) != -1 && this.isClinicalNotes && this.SelectedItem.customFrame == 'TFMDFORMDESIGNERRENDERING'; //this.SelectedItem.module == 'Clinical Notes' && this.SelectedItem.customFrame == 'TFMDFORMDESIGNERRENDERING';
        },

        isClinicalNoteDocumentDialogVisible() {
            return this.SelectedItem != null && ['WAA_INSERT', 'WAA_UPDATE', 'WAA_DELETE'].indexOf(this.SelectedItem.action) != -1 && this.isClinicalNotes && this.SelectedItem.customFrame == 'TFRMDOCUMENTNOTES';//this.SelectedItem.module == 'Clinical Notes' && this.SelectedItem.customFrame == 'TFRMDOCUMENTNOTES';
        },

        isAuthDialogVisible() {
            return this.SelectedItem != null && ['WAA_LOGIN', 'WAA_LOGOUT', 'WAA_UNAUTHORIZED'].indexOf(this.SelectedItem.action) != -1;
        }
    },

    methods: {
        SearchAudits(showLoading) {
            this.currentPage = 1;
            this.HandleSearchAudits(showLoading);
        },

        HandleSearchAudits(showLoading) {
            this.$emit('load', showLoading);
            this.paramAudits.PageNumber = this.currentPage;
            AuditService.getAll(this.paramAudits)
                .then((response) => {
                    if(response.data){   
                        this.items = response.data;
                        this.items.forEach((element) => {  
                            let { sysDate  } = element 
                            if (sysDate) element.sysDate = `${Utils.formatterDateTimeToString(sysDate)}`;
                            element.actionTrans = AuditUtils.translateAction(element.action);
                            element.moduleTrans = AuditUtils.translateModule(element.module);   
                        });

                        let headerString = response.headers["x-pagination"];
                        const Header = JSON.parse(headerString);
                        this.totalRows = Header.TotalCount;
                    }

                    if (this.items.length === 0) {
                        this.ShowMessageIsEmpty = true;
                    }  
                    this.$emit('load', false);
                })
                .catch(error => {      
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                });
        },

        ChangeDropDownPatients(value) {
            this.paramAudits.Patients = value.length > 0 ? value.map(x => x.patientcode).join(',') : '';
        },

        ChangeAction(value){
            this.paramAudits.ActionCode = value.map(x => x.value).join(",");
        },

        ChangeModule(value) {
            this.paramAudits.Modules = value.map(x => x.value).join(",");
        },

        customLabelPatients ({ patientname, patientcode }) {
            if (!Utils.isNullOrEmptyString(patientname) && !Utils.isNullOrEmptyString(patientcode)) {
                return `${patientname} – ${patientcode}`
            }
            
            return '*';
        },

        GoToAudit(item) {
            this.SelectedItem = item;
            if (this.isClinicalNoteDocumentDialogVisible) {
                this.ClinicalNoteDocumentItem = item;
            } else if (this.isClinicalNotesDialogVisible) {
                this.ClinicalNoteItem = item;
            } else if (this.isAuthDialogVisible) {
                this.AuthItem = item;
            } else if (this.isCRUDDialogVisible) {
                this.CrudItem = item;
            }

            //console.log(this.isClinicalNoteDocumentDialogVisible, this.isClinicalNotesDialogVisible, this.isAuthDialogVisible, this.isCRUDDialogVisible)
        },

        pageChanged (page) {            
            this.currentPage = page;
            this.HandleSearchAudits(true);
        },

        PerPageFunction(perpage){
            this.perPage = perpage;
            this.currentPage = 1;
            this.paramAudits.PageSize = this.perPage;
            this.HandleSearchAudits(true);
        },

        getPatients() {   
            PatientService.getAll({
                            PageSize:0,
                            PageNumber:0
                })
                .then((response) => {
                    if(response.status == '200' && response.data && response.data.length > 0){
                        this.PatientsList = response.data; 
                        this.PatientsList.forEach(function(element) {	
                            element.patientname = element.firstname + " " + element.lastname;   
                        });       
                    }    
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });    
        },

        handleClose() {
            this.SelectedItem = null;
            this.AuthItem = null;
            this.CrudItem = null;
            this.ClinicalNoteItem = null;
            this.ClinicalNoteDocumentItem = null;
        },

        HandleDatePressEnter() {
            this.SearchAudits(true);
        },

        goToWebAuditSettings() {
            this.$router.push({ name: "auditSettingListing"});
        }
    },

    async mounted() {
        this.OptionsRightMenu.ItemsList = EnumService.ClinicalItems
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
            case 'L0R1':
            this.OptionsRightMenu.favButtonAtion = true;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            default:
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }  

        this.$emit('load', true);
        await this.getPatients();   

        EventBus.$on("ShowWeel", function (isShow) { 
            isShow ? this.$emit('load', true) : this.$emit('load', false);     
        }.bind(this));

        await this.SearchAudits(false);
    },
};
</script>